export const _en = {
    id: {
        label: "Id"
    },
    resourceId: {
        label: "Resource"
    },
    refSkillId: {
        label: "Skill"
    },
    refSkillLevelId: {
        label: "Skill level"
    },
    startDate: {
        label: "Start date"
    },
    observationDate: {
        label: "Last skill observation date"
    },
    finishDate: {
        label: "Finish date"
    },
    lastFinishDate: {
        label: "Last known validity date"
    }
};

export const _fr = {
    id: {
        label: "Id"
    },
    resourceId: {
        label: "Ressource"
    },
    refSkillId: {
        label: "Qualification"
    },
    refSkillLevelId: {
        label: "Niveau de compétence"
    },
    startDate: {
        label: "Date de début de validité"
    },
    observationDate: {
        label: "Date d'observation"
    },
    finishDate: {
        label: "Date de fin de validité"
    },
    lastFinishDate: {
        label: "Avant dernière date de validité"
    }
};